import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { IAnnotation } from "@formant/core/model/IAnnotation";
import { IEvent } from "@formant/core/model/IEvent";
import { IEventOrAggregate } from "@formant/core/model/IEventOrAggregate";
import { IFilter } from "@formant/core/model/IFilter";
import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import { eventStore, observeStore } from "../../stores";
import { Escape } from "../common/Escape";
import { AnnotationForm } from "./AnnotationForm";
import { EventDetail } from "./EventDetail";
import * as styles from "./EventSidebar.scss";
import { ListEvents } from "./ListEvents";

export interface IEventSidebarProps {
    context: IFilter;
    filter?: IFilter;
    isV2View?: boolean;
    onAnnotate?: (annotation: Partial<IAnnotation>) => void;
    onSeek?: (time: Date) => void;
    onSelectEvent?: (event: IEventOrAggregate) => void;
}

@observer
export class EventSidebar extends Component<IEventSidebarProps> {
    public componentDidUpdate(newProps: IEventSidebarProps) {
        const { selectedEventId } = observeStore;
        const { deviceIds } = newProps.context;
        const oldDeviceIds = this.props.context.deviceIds;

        const selectedEvent =
            selectedEventId && eventStore.get(selectedEventId);

        if (
            selectedEvent &&
            selectedEvent.deviceId &&
            oldDeviceIds !== deviceIds &&
            !(deviceIds || []).includes(selectedEvent.deviceId)
        ) {
            observeStore.closeEventSidebar();
        }
    }

    public render() {
        const { onClose } = this;
        const { context, filter, onAnnotate, onSeek, onSelectEvent, isV2View } =
            this.props;
        const { eventSidebar, selectedEventId, editingAnnotation, seekOption } =
            observeStore;

        const selectedEvent =
            selectedEventId && (eventStore.get(selectedEventId) as IEvent);

        const title = {
            Comments: "Comments",
            Annotations: "Annotations",
            Commands: "Commands",
            "Data presence": "Events",
            "All other events": "Other events",
            Notifications: "Notifications",
        }[seekOption];

        return (
            <div
                className={classnames(
                    styles["event-sidebar"],
                    eventSidebar !== "open" && styles.invisible,
                    isV2View && styles["v2-view-styles"],
                )}
            >
                {!selectedEventId && !editingAnnotation && (
                    <ListEvents
                        title={title}
                        context={context}
                        filter={filter}
                        onAnnotate={onAnnotate}
                        onSeek={onSeek}
                        onSelectEvent={onSelectEvent}
                    />
                )}
                {!editingAnnotation && selectedEventId && selectedEvent && (
                    <EventDetail
                        title={title}
                        event={selectedEvent}
                        context={context}
                        filter={filter}
                    />
                )}
                <LoadingIndicator
                    visible={
                        !editingAnnotation &&
                        !!selectedEventId &&
                        !selectedEvent
                    }
                />
                {editingAnnotation && (
                    <AnnotationForm annotation={editingAnnotation} />
                )}
                <Escape onEsc={onClose} />
            </div>
        );
    }

    private onClose = () => {
        observeStore.closeEventSidebar();
    };
}
